import gql from 'graphql-tag';

import type { TextAnnotationMap } from 'src/data/annotation';
import type { AllInstructionsData } from 'src/data/generation';
import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type { BackendMutationExtractBriefAnnotationsArgs } from 'src/types/backend';

import { FRAGMENT_TEXT_ANNOTATIONS } from './schema';

const MUTATION = gql`
  mutation ExtractBriefAnnotations(
    $customerId: ID!
    $generationTool: GenerationToolEnum!
    $brief: BriefInput!
    $promptImageId: ID
    $promptDocumentId: ID
    $maxWords: Int
    $freestyleToolAllInstructionsData: JSON
    $urlExtractions: [UrlExtractionInput!]
  ) {
    extractBriefAnnotations(
      customerId: $customerId
      generationTool: $generationTool
      brief: $brief
      promptImageId: $promptImageId
      promptDocumentId: $promptDocumentId
      maxWords: $maxWords
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
      urlExtractions: $urlExtractions
    ) {
      ...TextAnnotations
    }
  }
  ${FRAGMENT_TEXT_ANNOTATIONS}
`;

type Variables = Override<
  BackendMutationExtractBriefAnnotationsArgs,
  {
    freestyleToolAllInstructionsData?: AllInstructionsData;
  }
>;

export const extractBriefAnnotations = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
): Promise<TextAnnotationMap | undefined> => {
  const { freestyleToolAllInstructionsData, ...rest } = variables;

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      freestyleToolAllInstructionsData: stringifyIfPresent(freestyleToolAllInstructionsData),
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });

  return getSingleProp<TextAnnotationMap>(result.data);
};
